import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";
import DetailReportPage from "./Pages/Detail";
import { SCREEN } from "helper/roleChecker/Screens";

const MainPage = lazy(() => import("./Pages/Main"));

export const researchReportRoutes = [
  {
    page: MainPage,
    path: pathRoutes.researchReport.parameter,
    screenCode: SCREEN.IP_011,
  },
  {
    page: DetailReportPage,
    path: pathRoutes.researchReport.detail.parameter,
    screenCode: SCREEN.IP_011,
  },
];
